import { ChecklistItem } from "."

export const PageSections = ({ forConfirmed }) => {
    return (
        <ChecklistItem forConfirmed={forConfirmed}>Add unlimited page sections to each page</ChecklistItem>
    )
}